export default function downloadFile(filename, _blob, type = "text/csv; charset=utf-8", isBlob = false) {
  const blob = isBlob ? _blob : new Blob(_blob, { type });
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    const elem = window.document.createElement("a");
    elem.classList.add("hidden");
    elem.href = window.URL.createObjectURL(blob);
    elem.download = filename;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
  }
}
